var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('div',{attrs:{"id":"landing"}},[_c('HeroImage'),_c('CallToAction'),_c('span',{staticClass:"scroll-indication scroll-alert-icon"})],1),_c('div',{staticClass:"section"},[_c('Map')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }